import RequesterList from './RequesterList';

export default RequesterList;
